import Heading from 'components/global/Heading'
import Bilboard from 'assets/images/bilboard.png';
import './styles.css';
import { Swiper, SwiperSlide } from "swiper/react";

import { Autoplay, Pagination , Navigation } from "swiper";

const TopLocations = () => {


    return (
        <div className=' h-full py-20'>
            <Heading
            title='Top Locations'
            subTitle='Our pick – Top billboards'
            />
            <div className=''>
                <Swiper
                    slidesPerView={3}
                    spaceBetween={30}
                    centeredSlides={true}
                    centeredSlidesBounds={true}
                    pagination={{
                        clickable: true,
                    }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    navigation={true}
                    speed={500}
                    loop={true}
                    modules={[Pagination , Autoplay , Navigation]}
                    className="centered-swiper"
                    breakpoints={{
                        650 : {
                            slidesPerView : 3
                        } ,
                        200 : {
                            slidesPerView : 1 
                        }
                    }}
                >
                    {
                        [...Array(5).keys()].map((item,i) => (
                            <SwiperSlide 
                            key={i}
                            >
                                <div className='relative'>
                                    <img 
                                    src={Bilboard} 
                                    alt="" 
                                    className='object-cover'
                                    />
                                    <div className='slide-text absolute -bottom-5 left-1/2 -translate-x-1/2 bg-[#dbdbdb77] w-[80%] py-2 px-2 rounded-md flex flex-col gap-4 text-center'>
                                        <h3>Time Square Billboard</h3>
                                        <p>Lorem ipsum dolor sit amet  elit.!</p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
        </div>
    )
}

export default TopLocations